import {GET_SUBMENU1, SUBMENU1_ERROR} from '../types'


export const getSubMenu1 = (singleMenu) => async dispatch => {
    
    try{
        dispatch( {
            type: GET_SUBMENU1,
            payload: singleMenu
        })
    }
    catch(error){
        console.log(error);
        dispatch( {
            type: SUBMENU1_ERROR,
            payload: error,
        })
    }

}


